export const MIN_NAME_LENGTH = 3;
export const MAX_SUGGESTIONS = 10;

export const QUICK_COMMANDS = [
    {
        id: "product",
        keyword: "produit",
        text: "quickMenu.commandProduct",
        icon: "shopping-cart.svg",
        linkId: "ADMIN_GROUPS",
        keywords: "produit product article artikel",
        source: {
            module: "product",
            state: "products",
            action: "ensureProducts",
            idKey: "productId",
            labelKey: "name"
        },
        route: "CatalogPage",
        query: "product",
        baseQuery: {view: "products"}
    },
    {
        id: "group",
        keyword: "groupe",
        text: "quickMenu.commandGroup",
        icon: "box.svg",
        linkId: "ADMIN_GROUPS",
        keywords: "groupe group categorie rayon groep",
        source: {
            module: "productGroup",
            state: "productGroups",
            action: "ensureProductGroups",
            idKey: "productGroupId",
            labelKey: "name"
        },
        route: "CatalogPage",
        query: "group"
    },
    {
        id: "client",
        keyword: "client",
        text: "quickMenu.commandClient",
        icon: "users.svg",
        linkId: "ADMIN_CLIENT_DATA",
        keywords: "client customer klant",
        source: {
            module: "client",
            state: "clientData",
            action: "getClientData",
            idKey: "clientDataId",
            labelKey: "name"
        },
        route: "clients",
        param: "clientDataId"
    },
    {
        id: "stock",
        keyword: "stock",
        text: "quickMenu.commandStock",
        icon: "box.svg",
        linkId: "ADMIN_GROUPS",
        keywords: "stock inventaire voorraad",
        source: {
            module: "product",
            state: "products",
            action: "ensureProducts",
            idKey: "productId",
            labelKey: "name"
        },
        route: "stock",
        param: "productId"
    },
    {
        id: "org",
        keyword: "org",
        minLength: 1,
        idPartial: true,
        text: "quickMenu.commandOrg",
        icon: "home.svg",
        keywords: "org orga organisation organization switch basculer changer bedrijf",
        source: {
            user: "managedOrganizations",
            idKey: "orgId",
            labelKey: "name"
        },
        switchOrg: true
    },
    {
        id: "account",
        keyword: "compte",
        text: "quickMenu.commandAccount",
        icon: "clock.svg",
        linkId: "ANALYTICS_ACCOUNTS",
        keywords: "compte account rekening ticket",
        idOnly: true,
        route: "AccountSummary",
        param: "accountId"
    },
    {
        id: "shift",
        keyword: "service",
        text: "quickMenu.commandShift",
        icon: "service2.svg",
        linkId: "ANALYTICS_SHIFTS",
        keywords: "service shift dienst cloture",
        idOnly: true,
        route: "ShiftDetailPage",
        param: "shiftId"
    },
    {
        id: "shiftStat",
        keyword: "statistiques",
        text: "quickMenu.commandShiftStat",
        icon: "statistic.svg",
        linkId: "ANALYTICS_SHIFTS",
        keywords: "statistique statistics service shift dienst",
        idOnly: true,
        route: "ShiftStatPage",
        param: "shiftId"
    }
];
